import { AppDispatch } from '@/root/store';
import { ShowWebsite } from '@/services/profile';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { SectionItem, SectionTabs } from '../_nav/section';

const sections: Record<string, string> = {
  info: 'Profil',
  // bills: 'Tagihan',
  website: 'Website',
  commerce: 'Keuangan',
  security: 'Keamanan',
};

export function OrgProfileLayout() {
  const location = useLocation();

  const dispatch: AppDispatch = useDispatch();

  const pathArray = location.pathname.split('/').slice(2);
  const section = pathArray[0];

  const { website } = useSelector((state: any) => state.profile);

  useEffect(() => {
    dispatch(ShowWebsite());
  }, []);

  const visibleSections = Object.entries(sections).filter(([key]) => {
    if (key === 'website' && Object.keys(website).length === 0) return false;
    return true;
  });

  return !section ? (
    <Navigate to='info' />
  ) : (
    <>
      <SectionTabs>
        {visibleSections.map(([key, value]) => {
          return (
            <SectionItem
              id={key}
              key={key}
              name={value}
              isCurrent={section === key}
            />
          );
        })}
      </SectionTabs>
      <Outlet />
    </>
  );
}
